<template>
  <component
    :is="tag"
    class="change-text-block">
    {{ text }}
  </component>
</template>

<script>
import {mapGetters} from "vuex";

const INTERVAL_TEXT_CHANGE = 5000
const INTERVAL_TYPING = 70
export default {
  name: 'ChangeTextBlock',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    text: {
      type: String,
      required: true
    },
    texts_to_change: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    ...mapGetters([
      'getResolution'
    ]),
    all_texts() {
      return [
        ...[this.text],
        ...this.texts_to_change
      ]
    },
    has_texts() {
      return this.all_texts.length > 1
    },
    current_el() {
      return this.$el
    },
    current_text() {
      return this.all_texts[this.text_index]
    }
  },
  mounted() {
    if (!this.has_texts) return
    setTimeout(() => { // add timeout to init font styles
      this.initChangeText()
    }, 500)
  },
  data() {
    return {
      timout_f: null,
      timout_f_char: null,
      text_index: 0,
      text_char_index: 0,
    }
  },
  methods: {
    calcElHeight() {
      this.current_el.style.minHeight = `${this.current_el.offsetHeight}px`
    },
    initChangeText() {
      this.calcElHeight()
      this.changeTypingText()
    },
    changeTypingText() {
      if (this.timout_f) {
        clearTimeout(this.timout_f)
      }
      this.timout_f = setInterval(() => {
        this.text_char_index = 0;
        this.current_el.innerHTML = ''
        this.animateTypingText()
        this.changeTypingText()
        this.changeTextIndex(this.text_index + 1)

      }, INTERVAL_TEXT_CHANGE)
    },
    animateTypingText() {
      if (this.timout_f_char) {
        clearInterval(this.timout_f_char)
      }
      if (this.text_char_index > this.current_text.length) {
        return
      }
      this.current_el.innerHTML += this.current_text.charAt(this.text_char_index);
      this.text_char_index++;
      this.timout_f_char = setTimeout(this.animateTypingText, INTERVAL_TYPING);
    },
    resetTimings() {
      this.text_index = 0
      this.text_char_index = 0
      this.current_el.innerHTML = this.text
      this.current_el.style.minHeight = ''
      this.calcElHeight()
      if (this.timout_f) {
        clearInterval(this.timout_f)
      }
      if (this.timout_f_char) {
        clearTimeout(this.timout_f_char)
      }
    },
    changeTextIndex(i) {
      this.text_index = i >= this.all_texts.length ? 0 : i
    }
  },
  watch: {
    'getResolution' () {
      this.resetTimings()
      this.$nextTick(() => {
        this.changeTypingText()
      })
    }
  }
}
</script>
